// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__Ex0Yk","InputError":"Form_InputError__RNppk","Error":"Form_Error__8WewZ","loader":"Form_loader__rqsFW"};